__turbopack_context__.v({
  "background": "TechBackground-module-scss-module__rZ--rG__background",
  "scrim": "TechBackground-module-scss-module__rZ--rG__scrim",
});
